import React from "react";
import { Box, Typography } from "@mui/material";
import SystemSettingsForm from "./forms/SystemSettingsForm";

interface SystemDetailsProps {
  system: any;
  onChange: (key: string, value: any) => void;
}

const SystemDetails: React.FC<SystemDetailsProps> = ({ system, onChange }) => (
  <Box>
    <Typography variant="h5" sx={{ mb: 2 }}>
      {system?.commonName || "Unnamed System"}
    </Typography>

    <Typography variant="h6" sx={{ mb: 2, color: "text.secondary" }}>
      System Info
    </Typography>

    <SystemSettingsForm system={system} handleChange={onChange} />
  </Box>
);


export default SystemDetails;
